module.exports = __webpack_public_path__ + "media/images/icons/use-content-f5914e261fdd18d0efea4f082b5f9a5c.svg";